import { render, staticRenderFns } from "./VideoParse.vue?vue&type=template&id=02038670&scoped=true"
import script from "./VideoParse.vue?vue&type=script&lang=js"
export * from "./VideoParse.vue?vue&type=script&lang=js"
import style0 from "./VideoParse.vue?vue&type=style&index=0&id=02038670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02038670",
  null
  
)

export default component.exports